import { render, staticRenderFns } from "./InputsManual.vue?vue&type=template&id=1846884c"
import script from "./InputsManual.vue?vue&type=script&lang=js"
export * from "./InputsManual.vue?vue&type=script&lang=js"
import style0 from "./InputsManual.vue?vue&type=style&index=0&id=1846884c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports